/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from 'gatsby';
import FormControl from './components/FormControl';
import { handleSubmit, validateOnChange } from './utils/helpers';
import formatUrlValue from '../Utilities/formatUrlValue';
import truncateUrl from '../Utilities/truncateUrl';
import { getUrlParam } from '../Utilities/getUrlParam';
import { useLightbox } from '../../../context/lightboxContext';
import {
  Container,
  Header,
  Form,
  TwoColumn,
  Button,
  Footer,
} from './styles/index.styled';

const EhsForm = ({ component, location }) => {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { closeLightbox } = useLightbox();
  const [data, setData] = useState({
    email: '',
    firstname: '',
    lastname: '',
    companyname: '',
    url: truncateUrl(location.href),
    jobtitle: '',
    industry: '',
    industrydetail: '',
    country: null,
    countrycode: '',
    state: null,
    DoNotRoute: true,
    LeadStatus: 'MQL',
    gclid: '',
  });
  const [validation, setValidation] = useState({
    firstname: '',
    lastname: '',
    email: '',
    companyname: '',
  });

  useEffect(() => {
    const url = formatUrlValue(location);
    setData({ ...data, url: truncateUrl(url) });
    setData({ ...data, gclid: getUrlParam('gclid') });
  }, []);

  const handleChange = e => {
    const { name, multiple, options, value } = e.target;

    const newValue = multiple
      ? Array.from(options)
          .filter(option => option.selected)
          .map(option => option.value)
      : value;

    setData(prev => ({ ...prev, [name]: newValue }));
    validateOnChange(e, name, validation, setValidation);
  };

  const requiredFields = ['firstname', 'lastname', 'companyname', 'email'];

  const hasErrors = Object.values(validation).some(value => value !== '');
  const hasEmptyRequiredFields = requiredFields.some(field => !data[field]);
  const isDisabled = hasErrors || hasEmptyRequiredFields;

  if (isSubmitted) {
    closeLightbox();
  }

  return (
    <Container>
      {component?.heading && <Header> {component.heading}</Header>}
      <Form
        id="demo-form"
        data-zi-mapped-form
        onSubmit={e =>
          handleSubmit({
            e,
            data,
            setData,
            validation,
            setValidation,
            customFormHandler: component?.pardotFormHandler,
            setIsSubmitted,
            chiliPiperRouterId: component?.chiliPiperRouterId,
          })
        }
      >
        <TwoColumn>
          <FormControl
            id="firstname"
            type="text"
            name="firstname"
            placeholder={t('Enter your first name')}
            label={t('First Name')}
            autoComplete="given-name"
            required
            errorMessage={validation.firstname}
            value={data.firstname}
            handleChange={handleChange}
          />
          <FormControl
            id="lastname"
            type="text"
            name="lastname"
            placeholder={t('Enter your last name')}
            label={t('Last Name')}
            autoComplete="family-name"
            required
            errorMessage={validation.lastname}
            value={data.lastname}
            handleChange={handleChange}
          />
        </TwoColumn>
        <FormControl
          id="companyname"
          type="text"
          name="companyname"
          placeholder={t('Enter your company name')}
          label={t('Company Name')}
          autoComplete="organization"
          required
          errorMessage={validation.companyname}
          value={data.companyname}
          handleChange={handleChange}
        />
        <FormControl
          id="email"
          type="email"
          name="email"
          placeholder={t('Enter your business email address')}
          label={t('Business Email Address')}
          required
          autoComplete="email"
          errorMessage={validation.email}
          value={data.email}
          handleChange={handleChange}
        />
        <FormControl
          id="jobtitle"
          type="text"
          name="jobtitle"
          placeholder="Job Title"
          label="Job Title"
          autoComplete="on"
          value={data.jobtitle}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="industry"
          type="text"
          name="industry"
          placeholder="Industry"
          label="Industry"
          autoComplete="on"
          value={data.industry}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="industrydetail"
          type="text"
          name="industrydetail"
          placeholder="Industry Details"
          label="Industry Details"
          autoComplete="on"
          value={data.industrydetail}
          handleChange={handleChange}
          hidden
        />
        <input
          type="text"
          id="DoNotRoute"
          name="DoNotRoute"
          value={data.DoNotRoute}
        />
        <input
          type="text"
          id="LeadStatus"
          name="LeadStatus"
          value={data.LeadStatus}
        />
        <input type="text" id="gclid" name="gclid" value={data.gclid} />
        <Button type="submit" className={`${isDisabled ? 'disabled' : ''}`}>
          {component?.callToAction || t('Submit')}
        </Button>
      </Form>
      <Footer>
        <div className="use-policy">
          <p>
            {t('By clicking above, you agree to the')}{' '}
            <Link to="/terms">{t('UpKeep Terms of Use')}.</Link>
          </p>
        </div>
      </Footer>
    </Container>
  );
};

export default EhsForm;
